<script>
import appConfig from "@src/app.config";
import PageHeader from "@components/page-header";
import SalesService from "@services/resources/SalesService";
import Button from "./components/Button.vue";
import EmailIcon from "@src/assets/img/icons/email.svg";
import HashtagIcon from "@src/assets/img/icons/hashtag.svg";
import PhoneIcon from "@src/assets/img/icons/phone.svg";
import DocumentIcon from "@src/assets/img/icons/document.svg";
import ClientIcon from "@src/assets/img/icons/client.svg";
import ReloadIcon from "@src/shared/icons/reload.svg";
import FilterFunnelIcon from "@src/shared/icons/filter-funnel.svg";
import SearchIcon from "@src/shared/icons/search.svg";
import { getSaleStatusList } from "@src/helpers/sale";
import { getPaymentMethodList } from "@src/helpers/payment";
import { getCurrentMonthRange, formatDateISO, formatDateBR } from "@src/helpers/date";
import { validateCpf } from "@src/helpers/documentValidator";
import { getGatewayList } from "@src/helpers/gateways";
import SalesTable from "./list/SalesTable.vue";
import Pagination from "@src/components/ui-design/paginations/Pagination.vue";
import DateRangeCalendar from "@src/components/ui-design/calendar/DateRangeCalendar.vue";
import CompactMultiSelect from "@src/components/ui-design/form/CompactMultiSelect.vue";

export default {
  page: {
    title: "Vendas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  name: "SalesList",
  components: {
    Button,
    CompactMultiSelect,
    SalesTable,
    DateRangeCalendar,
    PageHeader,
    Pagination,
  },
  data() {
    const monthRange = getCurrentMonthRange();

    return {
      service: SalesService.build(),
      fetchSalesRequestId: 0,
      items: [
        { text: "Início", href: "/" },
        { text: "Vendas", active: true },
      ],
      loading: true,
      sales: [],
      date: {
        startDate: monthRange.startDate,
        endDate: monthRange.endDate,
      },
      activeHover: "",
      searchIcon: SearchIcon,
      filterFunnelIcon: FilterFunnelIcon,
      reloadIcon: ReloadIcon,
      searchValue: "",
      searchFilter: [
        {
          type: "id",
          icon: HashtagIcon,
          text: "Buscar pelo ID",
          title: "Use o ID Transação ou ID Greenn",
          props: {
            type: "text",
          },
        },
        {
          type: "client_email",
          icon: EmailIcon,
          text: "E-mail do cliente",
          title: null,
          props: {
            type: "email",
          },
        },
        { type: "client_name", icon: ClientIcon, text: "Nome do cliente", title: null },
        {
          type: "client_cellphone",
          icon: PhoneIcon,
          text: "Telefone do cliente",
          title: null,
          props: {
            type: "text",
          },
        },
        {
          type: "client_document",
          icon: DocumentIcon,
          text: "Documento do cliente",
          title: null,
          props: {
            type: "text",
          },
        },
      ],
      selectedSearchFilter: {
        props: {},
        type: "",
        icon: "",
        text: "",
      },
      filters: {
        id: [],
        client_email: "",
        client_name: "",
        client_cellphone: "",
        client_document: "",
        date_start: formatDateISO(monthRange.startDate),
        date_end: formatDateISO(monthRange.endDate),
        status: [],
        methods: [],
        gateways: [],
      },
      pagination: {
        total: 1,
        page: 1,
        perPage: 20,
        pageOptions: [20, 50, 100],
      },
    };
  },
  mounted() {
    this.fetchSales();
  },
  methods: {
    getSaleStatusList,
    getPaymentMethodList,
    formatDateBR,
    getGatewayList,
    applyFilters() {
      this.pagination.page = 1;
      this.fetchSales();
    },
    handleDate(newDate) {
      if (newDate.startDate && newDate.endDate) {
        this.date = newDate;
        this.filters.date_start = formatDateISO(newDate.startDate);
        this.filters.date_end = formatDateISO(newDate.endDate);
      } else {
        const range = getCurrentMonthRange();

        this.date = {
          startDate: range.startDate,
          endDate: range.endDate,
        };

        this.filters.date_start = formatDateISO(range.startDate);
        this.filters.date_end = formatDateISO(range.endDate);
      }
    },
    removeFilter(selectedFilter, id) {
      this.filters[selectedFilter] = this.filters[selectedFilter].filter(
        (item) => item.id !== id
      );
    },
    handleFilters() {
      if (this.activeHover === "filters") {
        return (this.activeHover = "");
      }

      this.activeHover = "filters";
    },
    resetSearch(type = "full") {
      if (type === "search" || type === "full") {
        this.filters.id = [];
        this.filters.client_email = "";
        this.filters.client_name = "";
        this.filters.client_cellphone = "";
        this.filters.client_document = "";
      }

      if (type === "filters" || type === "full") {
        const range = getCurrentMonthRange();
        this.date.startDate = range.startDate;
        this.date.endDate = range.endDate;
        this.filters.date_start = formatDateISO(range.startDate);
        this.filters.date_end = formatDateISO(range.endDate);
        this.filters.status = [];
        this.filters.methods = [];
        this.filters.gateways = [];
      }

      if (type !== "filters") this.activeHover = "";

      this.pagination.page = 1;

      this.fetchSales();
    },
    removeSearch(type) {
      this.filters[type] = "";

      if (type === "id") {
        this.filters[type] = [];
      }
      this.pagination.page = 1;
      this.fetchSales();
    },
    removeIdFilter(id) {
      this.filters.id = this.filters.id.filter((item) => item !== id);
      this.pagination.page = 1;
      this.fetchSales();
    },
    validateFields() {
      const searchValue = this.searchValue.trim();

      if (!searchValue) {
        this.searchValue = "";

        this.$bvToast.toast("Preencha o campo.", {
          variant: "warning",
          title: "Atenção!",
          autoHideDelay: 5000,
        });

        return false;
      }

      if (
        this.selectedSearchFilter.type === "id" &&
        this.filters.id.includes(searchValue)
      ) {
        this.$bvToast.toast("Este id já foi selecionado.", {
          variant: "warning",
          title: "Atenção!",
          autoHideDelay: 5000,
        });

        return false;
      }

      if (this.selectedSearchFilter.type === "client_cellphone") {
        const digits = searchValue.replace(/\D/g, "");

        if (digits.length < 10) {
          this.$bvToast.toast("Preencha o telefone completo.", {
            variant: "warning",
            title: "Atenção!",
            autoHideDelay: 5000,
          });

          return false;
        }
      }

      if (this.selectedSearchFilter.type === "client_document") {

        if (!validateCpf(searchValue)) {
          this.$bvToast.toast("Esse CPF não é válido.", {
            variant: "warning",
            title: "Atenção!",
            autoHideDelay: 5000,
          });

          return false;
        }
      }

      this.searchValue = searchValue;

      return true;
    },
    fetchSearchFilter() {
      if (!this.validateFields()) return;

      const searchValue = this.searchValue.trim();

      if (this.selectedSearchFilter.type === "id") {
        this.filters.id.push(searchValue);
      } else {
        this.filters[this.selectedSearchFilter.type] = searchValue;
      }

      this.$refs.searchDropdown.hide();

      this.pagination.page = 1;

      this.fetchSales();
    },
    handleSearchFilter(filter) {
      this.searchValue = "";

      if (!filter.text) {
        this.activeHover = "";
      }

      this.selectedSearchFilter.type = filter.type;
      this.selectedSearchFilter.icon = filter.icon;
      this.selectedSearchFilter.text = filter.text;
      this.selectedSearchFilter.props = filter.props;
    },
    changePerPage(perPage) {
      this.pagination.perPage = perPage;
      this.pagination.page = 1;
      this.fetchSales();
    },
    changeCurrentPage(currentPage) {
      this.pagination.page = currentPage;
      this.fetchSales();
    },
    async fetchSales() {
      this.fetchSalesRequestId++;

      const requestId = this.fetchSalesRequestId;

      try {
        this.loading = true;

        const filters = {
          page: this.pagination.page,
          per_page: this.pagination.perPage,
          currency: "BRL",
          date_start: this.filters.date_start,
          date_end: this.filters.date_end,
        };

        if (this.filters.id && this.filters.id.length) {
          filters.id = this.filters.id.join(";");
        }
        if (this.filters.client_email) filters.client_email = this.filters.client_email;
        if (this.filters.client_name) filters.client_name = this.filters.client_name;
        if (this.filters.client_cellphone)
          filters.client_cellphone = this.filters.client_cellphone.replace(/\D/g, "");
        if (this.filters.client_document)
          filters.client_document = this.filters.client_document;

        if (this.filters.status.length) {
          filters.statuses = this.filters.status.map((status) => status.id);
        }

        if (this.filters.methods.length) {
          filters.methods = this.filters.methods.map((method) => method.id);
        }

        if (this.filters.gateways.length) {
          filters.gateways = this.filters.gateways.map((gateway) => gateway.id);
        }

        const response = await this.service.search(filters)

        if (requestId !== this.fetchSalesRequestId) return;

        const responseData = response && response.data;

        this.sales = (responseData && responseData.data) || [];
        this.pagination.total = (responseData && responseData.total) || 0;
      } catch (err) {
        if (requestId !== this.fetchSalesRequestId) return;

        this.$bvToast.toast("Não foi possível buscar as vendas.", {
          title: "Ops, algum erro aconteceu",
          variant: "danger",
          solid: true,
          autoHideDelay: 2000,
        });
      } finally {
        if (requestId === this.fetchSalesRequestId) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader title="Gestão de Vendas" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="sales card-box px-0">
          <div class="sales__header px-3">
            <h4 class="page-title">Vendas</h4>
            <div class="sales-filters">
              <b-dropdown id="searchDropdown" ref="searchDropdown" variant="link"
                toggle-class="text-decoration-none p-0" right no-caret boundary="scrollParent"
                @hidden="handleSearchFilter({ action: '', text: '' })">
                <template #button-content>
                  <Button tag="div" :activeHover="activeHover === 'find'" label="Buscar" :icon-src="searchIcon"
                    @click="activeHover = 'find'" />
                </template>
                <template v-if="!selectedSearchFilter.text">
                  <b-dropdown-item v-for="(action, index) in searchFilter" :key="index"
                    v-b-tooltip.hover="action.title">
                    <div class="d-flex justify-content-between" style="gap: 1rem; color: #000c0b"
                      @click.stop="handleSearchFilter(action)">
                      <div>
                        <span>{{ action.text }}</span>
                      </div>
                      <div>
                        <img :alt="`Ícone do filtro ${action.text}`" :src="action.icon" />
                      </div>
                    </div>
                  </b-dropdown-item>
                </template>
                <b-dropdown-item v-if="selectedSearchFilter.text" class="sales-filters__selected" @click.stop="">
                  <div @click.stop="">
                    <div class="d-flex gap-4 align-items-center mb-1" style="gap: 0.75rem; color: #000c0b"
                      @click.stop="">
                      <img :alt="`Ícone do filtro ${selectedSearchFilter.text}`" :src="selectedSearchFilter.icon"
                        @click.stop="" />
                      <h5 style="color: #000c0b; font-weight: 700" @click.stop="">
                        {{ selectedSearchFilter.text }}
                      </h5>
                    </div>
                    <form @submit.prevent="fetchSearchFilter()">
                      <b-form-input v-if="selectedSearchFilter.type === 'client_document'" v-model="searchValue"
                        :placeholder="selectedSearchFilter.text" class="form-control mb-2" v-mask="'###.###.###-##'"
                        @click.stop=""></b-form-input>
                      <b-form-input v-else-if="selectedSearchFilter.type === 'client_cellphone'" v-model="searchValue"
                        :placeholder="selectedSearchFilter.text" class="form-control mb-2" v-mask="'(##) #####-####'"
                        @click.stop=""></b-form-input>
                      <b-form-input v-else v-model="searchValue" v-bind="selectedSearchFilter.props"
                        :placeholder="selectedSearchFilter.text" class="form-control mb-2"
                        @click.stop=""></b-form-input>

                      <div class="sales-filters__actions">
                        <b-button class="sales-filters__actions--cancel" v-b-tooltip.hover
                          @click.stop="handleSearchFilter({ action: '', text: '' })">
                          Cancelar
                        </b-button>
                        <b-button class="sales-filters__actions--search" v-b-tooltip.hover type="submit">
                          Buscar
                        </b-button>
                      </div>
                    </form>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <Button :activeHover="activeHover === 'filters'" label="Filtros" :icon-src="filterFunnelIcon"
                @click="handleFilters" />
              <Button label="Atualizar" :icon-src="reloadIcon" @click="resetSearch('full')" />


            </div>
          </div>

          <div class="row mb-3" v-if="
            filters.id.length ||
            filters.client_email ||
            filters.client_name ||
            filters.client_cellphone ||
            filters.client_document
          ">
            <div class="col-12">
              <div class="px-3 d-flex align-items-center justify-content-between">
                <div class="d-flex" style="gap: 1rem">
                  <template v-if="filters.id">
                    <b-badge class="sales__badge" variant="info" v-for="id in filters.id" :key="id">ID: #{{ id }}
                      <a href="#" title="Remover filtro" @click="removeIdFilter(id)">
                        <i class="mdi mdi-close"></i></a>
                    </b-badge>
                  </template>
                  <b-badge v-if="filters.client_email" class="sales__badge" variant="info">
                    E-mail: {{ filters.client_email }}
                    <a href="#" title="Remover filtro" @click="removeSearch('client_email')">
                      <i class="mdi mdi-close"></i></a>
                  </b-badge>
                  <b-badge v-if="filters.client_name" class="sales__badge" variant="info">
                    Nome: {{ filters.client_name }}
                    <a href="#" title="Remover filtro" @click="removeSearch('client_name')">
                      <i class="mdi mdi-close"></i></a>
                  </b-badge>
                  <b-badge v-if="filters.client_cellphone" class="sales__badge" variant="info">
                    Telefone: {{ filters.client_cellphone }}
                    <a href="#" title="Remover filtro" class="mb-0" @click="removeSearch('client_cellphone')">
                      <i class="mdi mdi-close"></i></a>
                  </b-badge>
                  <b-badge v-if="filters.client_document" class="sales__badge" variant="info">
                    Documento: {{ filters.client_document }}
                    <a href="#" title="Remover filtro" @click="removeSearch('client_document')">
                      <i class="mdi mdi-close"></i>
                    </a>
                  </b-badge>
                </div>
                <a class="sales__reset-search" href="#" @click="resetSearch('search')">
                  <i class="mdi mdi-close mr-1"></i>Limpar busca
                </a>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="row mb-3" v-show="activeHover === 'filters'">
              <div class="col-12">
                <div class="px-3 row sales-advanced-filter">
                  <b-form-group class="col-3" label="Data da venda">
                    <DateRangeCalendar :value="date" @change="handleDate" />
                  </b-form-group>
                  <b-form-group class="col-3" label="Status da venda">
                    <CompactMultiSelect v-model="filters.status" :options="getSaleStatusList()"
                      placeholder="Selecione o status..." @remove="removeFilter('status', $event)" />
                  </b-form-group>
                  <b-form-group class="col-3" label="Método de pagamento">
                    <CompactMultiSelect v-model="filters.methods" :options="getPaymentMethodList()"
                      placeholder="Selecione o método..." @remove="removeFilter('methods', $event)" />
                  </b-form-group>
                  <b-form-group class="col-3" label="Gateway">
                    <CompactMultiSelect v-model="filters.gateways" :options="getGatewayList()"
                      placeholder="Selecione o Gateway..." @remove="removeFilter('gateways', $event)" />
                  </b-form-group>
                </div>
                <div class="px-3 d-flex justify-content-end" style="gap: 1rem">
                  <b-button variant="outline-primary" class="sales-filters__button sales-filters__button--clear"
                    @click="resetSearch('filters')">
                    <span>Limpar filtros</span>
                  </b-button>
                  <b-button variant="outline-primary"
                    class="sales-filters__button sales-filters__button--apply sales-filters__button--active"
                    @click="applyFilters">
                    <span>Aplicar filtro</span>
                  </b-button>
                </div>
              </div>
            </div>
          </transition>
          <div v-if="sales.length > 0 && !loading" class="row">
            <div class="col-12">
              <SalesTable :sales="sales" />
            </div>
          </div>
          <div v-if="sales.length > 0 && !loading" class="row px-3">
            <b-col cols="12" sm="12">
              <Pagination :page="pagination.page" :total="pagination.total" :perPage="pagination.perPage"
                :pageOptions="pagination.pageOptions" @page="changeCurrentPage" @perPage="changePerPage" />
            </b-col>
          </div>
          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-if="sales.length === 0 && !loading" class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Não há vendas realizadas neste período de
              {{ formatDateBR(filters.date_start) }} à
              {{ formatDateBR(filters.date_end) }}.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.sales {
  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  &__badge {
    font-size: 14px;
    font-weight: 600;
    padding: 8px 12px;
    border-radius: 20px;
    color: #1a52db;
    background: #eff6ff;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    a {
      cursor: pointer;
      margin-bottom: 0;
    }
  }

  &__reset-search {
    color: #999e9d;
    margin-bottom: 0;
  }
}

.sales-filters {
  display: flex;
  gap: 1rem;

  &__button {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #000c0b;
    border-color: #f0f2f5 !important;
    border-radius: 8px;
    padding: 14px;
    box-shadow: none !important;
    background-color: #f0f2f5 !important;
    width: fit-content;
    min-width: 44px;
    height: 44px;

    &--apply {
      font-weight: 600;
    }

    &--clear {
      background: #fff !important;
      color: black !important;
      border: 0;
    }

    &--active {
      display: flex;
      gap: 0.5rem;
      background-color: #000c0b !important;
      box-shadow: none !important;
      border-color: #000c0b !important;
      color: #fff;
      border: 0;

      i {
        margin-right: 0.5rem;
      }

      .sales-filters__button-text {
        display: flex !important;
      }
    }
  }

  &__selected {
    width: 260px;

    .dropdown-item {
      background-color: inherit;
    }
  }

  &__actions {
    display: flex;
    gap: 0.5rem;

    button {
      width: 100%;
      border-radius: 5px !important;
      font-weight: 700;
    }

    &--search {
      background: #000c0b !important;
    }

    &--cancel {
      background: #f0f2f5 !important;
      color: #000c0b !important;
      border: none;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
